// import React from 'react';
// import { Link } from 'react-router-dom';
// import './HeroTextOverlay.css';

// const HeroTextOverlay = () => {
//     return (
//         <div className="hero-text-overlay">
//             <div className="hero-text-content">
//                 <div className="brand-logo">
//                     <h1 className="logo-text">MAAK</h1>
//                     <div className="logo-subtitle">DREAM</div>
//                 </div>
//                 <div className="hero-content">
//                     <h2 className="hero-title">
//                         Redefining <span className="highlight">Urban Living</span>
//                     </h2>
//                     <p className="hero-subtitle">
//                         A legacy continues from Pakistan to Dubai<br />
//                         Over 70 years of engineering excellence in construction<br />
//                         and urban development.
//                     </p>
//                     <div className="hero-buttons">
//                         <Link className="primary-btn" to="/project">
//                             <span>Discover Properties</span>
//                         </Link>
//                         <Link className="secondary-btn" to="/about">
//                             <span>Learn More</span>
//                         </Link>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HeroTextOverlay;










import React from 'react';
import './HeroTextOverlay.css';
import { Link } from 'react-router-dom';

const HeroTextOverlay = ({
    logoText,
    logoSubtitle,
    heroTitle,
    heroSubtitle,
    heroSubtitle2,
    heroSubtitle3,
    btnOneText,
    btnOneLink,
    btnTwoText,
    btnTwoLink
}) => {
    // Highlight last two words of hero title
    const splitTitle = heroTitle.split(' ');
    const lastTwoWords = splitTitle.slice(-2).join(' ');
    const firstWords = splitTitle.slice(0, -2).join(' ');

    return (
        <div className="hero-text-overlay">
            <div className="hero-text-content">
                <div className="brand-logo">
                    <h1 className="logo-text">{logoText}</h1>
                    <div className="logo-subtitle">{logoSubtitle}</div>
                </div>
                <div className="hero-content">
                    <h2 className="hero-title">
                        {firstWords} <span className="highlight">{lastTwoWords}</span>
                    </h2>
                    <p className="hero-subtitle">{heroSubtitle}</p>
                    {heroSubtitle2 && <p className="hero-subtitle">{heroSubtitle2}</p>}
                    {heroSubtitle3 && <p className="hero-subtitle">{heroSubtitle3}</p>}
                    <div className="hero-buttons">
                        <Link className="primary-btn" to={btnOneLink}>
                            <span>{btnOneText}</span>
                        </Link>
                        <Link className="secondary-btn" to={btnTwoLink}>
                            <span>{btnTwoText}</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroTextOverlay;
